import React from 'react';
import { IWizard } from 'use-wizard/lib/cjs/useWizard/types/IWizard';

import type { TStep } from 'use-wizard/lib/cjs/useWizard/types/TStep';

const OnboardingContext = React.createContext<{
  wizard: IWizard;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  steps: any;
}>({
  wizard: {
    nextStep: () => {},
    previousStep: () => {},
    nPreviousSteps: 0,
    nForwardSteps: 0,
    forwardStep: () => {},
    initialize: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    jumpSteps: (jump: number) => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    goToStep: (step: TStep) => {},
    history: [],
    stepIndex: () => 0,
    wizardLength: () => 0,
  },
  steps: {},
});

export const OnboardingProvider: React.FC<{
  wizard: IWizard;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  steps: any;
  children: React.ReactNode;
}> = ({ children, wizard, steps }) => {
  return (
    <OnboardingContext.Provider value={{ wizard, steps }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = React.useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within a OnboardingProvider');
  }
  return context;
};
